<template>
  <Testing />
</template>

<script>
import Testing from '@/components/Testing.vue'
  export default {
    name: 'Test',
    components: {
      Testing,
    },
  }
</script>

<style lang="scss" scoped>
@media screen and (max-width: 1096px) {
  #hometable {
    max-width: 100%;
  }
  #mobilesidebar {
    max-width: 100%;
  }
}
</style>